import { render } from "./MyRequests.vue?vue&type=template&id=820db512"
import script from "./MyRequests.vue?vue&type=script&lang=js"
export * from "./MyRequests.vue?vue&type=script&lang=js"

import exportComponent from "/Users/onisiforosgeorgiou/WebstormProjects/AgencyNow/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__